/**
 * AdjustSubscriptionCtrl controller
 * Add/Edit Payment statement comment
 */
import moment from 'moment'
import { CONTENT_TYPES_SETS } from '../../../app/core/constants'

/**
 * AdjustSubscriptionCtrl controller
 *
 * @class AdjustSubscriptionCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AdjustSubscriptionCtrl
 */
/* @ngInject */
export default function AdjustSubscriptionCtrl ($uibModalInstance, $http, $scope, subscriber, subscription, maxLength, addOns) {
  var vm = this

  /**
   * PaymentStatement
   *
   * @memberof mwApp/subscribers.controller:AdjustSubscriptionCtrl
   * @type {models.Purchase}
   */
  vm.subscription = subscription
  vm.adjustLengthType = 'DAYS'
  vm.adjustType = 'ADD'
  vm.adjustAddonsLength = false
  vm.adjustAllAddons = false

  vm.addons = addOns
  vm.content_types_sets = CONTENT_TYPES_SETS

  vm.extraLength = vm.maxSubscriptionLength === vm.curLength ? 0 : 1

  vm.curLength = Math.abs(new Date(vm.subscription.availableTo).getTime() - new Date(vm.subscription.availableFrom).getTime()) / (1000 * 3600 * 24)

  vm.maxSubscriptionLength = maxLength

  vm.expirationDateType = 'ADD'

  const minDate = new Date()
  minDate.setDate(minDate.getDate() + 1)
  minDate.setHours(0, 0, 0, 0)
  const maxDate = new Date(vm.subscription.availableFrom).getTime() + vm.maxSubscriptionLength * 24 * 3600 * 1000

  /**
   * Datepicker settings
   *
   * @memberof mwApp/subscribers.controller:AdjustSubscriptionCtrl
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: minDate,
    maxDate: maxDate,
    changeHandler: function (form) {
      const minDate = vm.expirationDate >= vm.dpCfg.minDate
      const maxDate = vm.expirationDate < vm.dpCfg.maxDate
      form.expirationDate.$setValidity('minDate', minDate)
      form.expirationDate.$setValidity('maxDate', maxDate)
      form.expirationDate.$setValidity('adjustLength', vm.adjustment() !== 0)
    }
  }

  vm.expirationDate = new Date(subscription.availableTo)

  /**
   * Handle open datepicker
   *
   * @memberof mwApp/subscribers.controller:AdjustSubscriptionCtrl
   */
  vm.open = function () {
    vm.dpCfg.opened = true
  }

  vm.activeUntil = function (form) {
    if (vm.adjustLengthType === 'DAYS') {
      if (form.extraLength && form.extraLength.$valid) {
        const activeUntil = angular.copy(vm.subscription.availableTo)
        if (vm.adjustType === 'ADD' && vm.extraLength) {
          activeUntil.add(vm.extraLength, 'days')
        }
        if (vm.adjustType === 'SUBTRACT' && vm.extraLength) {
          activeUntil.subtract(vm.extraLength, 'days')
          form.extraLength.$setValidity('max', moment(activeUntil.format('YYYY-MM-DD HH:mm')).isAfter((moment(Date.now()).add(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm'))))
        }
        return activeUntil
      } else {
        return NaN
      }
    } else {
      return vm.expirationDate
    }
  }

  vm.activeUntilAddons = function (form, addon) {
    if (vm.adjustAddonsLength && addon.$adjustEnabled) {
      return vm.activeUntil(form)
    }
    return angular.copy(vm.subscription.availableFrom).setDate(vm.subscription.availableFrom.getDate() + (addon.timeUnit === 'DAY' ? addon.period : addon.period * 30))
  }

  vm.cantSubtract = function () {
    const activeUntil = angular.copy(vm.subscription.availableTo)
    return activeUntil.subtract(1, 'days').format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
  }

  vm.adjustment = function () {
    if (vm.expirationDate) {
      const dateFrom = new Date(vm.subscription.availableFrom) > new Date() ? new Date(vm.subscription.availableFrom) : new Date()
      const dateUntil = new Date(vm.subscription.availableTo)
      const newUntil = new Date(vm.expirationDate)
      const currentLength = (moment(dateUntil.getTime()).startOf('day').valueOf() - moment(dateFrom.getTime()).startOf('day').valueOf()) / 1000 / 3600 / 24
      const newLength = (moment(newUntil.getTime()).startOf('day').valueOf() - moment(dateFrom.getTime()).startOf('day').valueOf()) / 1000 / 3600 / 24
      if (newLength >= currentLength) {
        vm.expirationDateType = 'Add'
        vm.expirationDateLength = newLength - currentLength
      } else {
        vm.expirationDateType = 'Subtract'
        vm.expirationDateLength = currentLength - newLength
      }
    }
    return vm.expirationDateLength
  }

  /**
   * Create or edit comment, and close modal window afterwards
   *
   * @memberof mwApp/subscribers.controller:AdjustSubscriptionCtrl
   */
  vm.submit = function (form) {
    if (vm.adjustLengthType === 'EXPIRATION') {
      vm.dpCfg.changeHandler(form)
    }
    if (form.$invalid) {
      return
    }
    vm.setDisable()
    let extraLengthChange
    if (vm.adjustLengthType === 'EXPIRATION') {
      if (vm.expirationDateType === 'Add') {
        extraLengthChange = vm.expirationDateLength
      } else {
        extraLengthChange = -1 * vm.expirationDateLength
      }
    } else {
      if (vm.adjustType === 'ADD') {
        extraLengthChange = vm.extraLength
      } else {
        extraLengthChange = -1 * vm.extraLength
      }
    }
    const contentAddonPurchaseItemIds = vm.addons.map(a => vm.adjustAddonsLength && a.$adjustEnabled ? a.purchaseItemId : null).filter(id => id !== null)

    $http.patch(`api/subscribers/${subscriber.id}/payments/${subscription.paymentStatementId}/extraLength`, { extraLengthChange, contentAddonPurchaseItemIds })
      .then(() => {
        $uibModalInstance.close()
      })
      .finally(() => {
        vm.unsetDisable()
      })
  }

  vm.showLength = function (form, addon) {
    if (vm.adjustAddonsLength && addon.$adjustEnabled) {
      if (!isNaN(vm.activeUntil(form))) {
        const timeDiff = moment(vm.activeUntil(form)).toDate().getTime() - (new Date()).getTime()
        const currentLength = Math.ceil(timeDiff / (1000 * 3600 * 24))
        const addonDiff = (new Date(addon.availableTo)).getTime() - (new Date()).getTime()
        const addonLength = Math.ceil(addonDiff / (1000 * 3600 * 24))
        addon.extraLength = currentLength - addonLength
        return addon.length + addon.unit[0] + (addon.extraLength !== 0 ? (' (' + (addon.extraLengthDays + addon.extraLength > 0 ? '+' + (addon.extraLengthDays + addon.extraLength) : (addon.extraLengthDays + addon.extraLength)) + 'D)') : '')
      } else {
        return addon.length + addon.unit[0] + ' ()'
      }
    }
    return addon.length + addon.unit[0] + (addon.extraLengthDays !== 0 ? (' (' + (addon.extraLengthDays > 0 ? '+' + addon.extraLengthDays : addon.extraLengthDays) + 'D)') : '')
  }

  vm.changeAdjust = function () {
    vm.adjustAllAddons = vm.addons.reduce((acc, a) => {
      return acc && a.$adjustEnabled
    }, true)
  }

  vm.changeAdjustAll = function () {
    vm.addons.forEach((a) => {
      a.$adjustEnabled = vm.adjustAllAddons
    })
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:AdjustSubscriptionCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
